import styled from 'styled-components';
import CheckBoxCheckedSvg from './../assets/checkbox-checked.svg';

const CheckBoxCheckedIcon = styled(CheckBoxCheckedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  margin-right: ${props => props.theme.spacing.base};
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  cursor: pointer;
`;

export default CheckBoxCheckedIcon;
